import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation } from "react-router-dom";
import { useMemo, useState } from "react";
import cn from "classnames";
import { QuickLink, QuickLinkProps } from "./QuickLink";
import { Container } from "components/Layout/Container";
import { PageLink } from "components/App/utils";
import { useUserAuthenticated, useUserGuest } from "components/utils";
import { isInIframe } from "components/utils/dom";
import { Collapse } from "react-bootstrap";

import "./styles.scss";
import { AccountForm } from "../AccountForm";

export function HeaderMenu() {
    const isGuest = useUserGuest();
    const [isExpanded, setIsExpanded] = useState(false);

    const isUserAuthenticated = useUserAuthenticated();
    const location = useLocation();

    const showHeader = useMemo(
        () =>
            isUserAuthenticated ||
            (isInIframe() && (location.pathname.includes(PageLink.CustomerHome) || location.pathname.includes(PageLink.ApplicationView))),
        [isUserAuthenticated, location]
    );

    if (!showHeader) {
        return null;
    }

    return (
        <nav className="header-menu">
            <Container className="header-menu-links d-flex flex-row justify-content-between">
                <div className="align-self-center">
                    <Link className="home-link menu-link" to={PageLink.CustomerHome} aria-label="My Applications List Portal Dashboard">
                        <FontAwesomeIcon icon={"house"} />
                        My applications
                    </Link>
                </div>
                <div className="header-quick-links d-none d-md-flex flex-row justify-content-end align-items-center">
                    {isGuest && <CreateAccount />}
                    {(isGuest ? guestQuickLinks : quickLinks).map((item, index) => (
                        <QuickLink key={index} text={item.text} href={item.href} icon={item.icon} iconClassName={item.iconClassName} />
                    ))}
                </div>
                <div
                    className={cn("quick-links-btn d-flex d-md-none align-items-center ", { expanded: isExpanded })}
                    onClick={() => setIsExpanded(!isExpanded)}
                    role="button"
                    tabIndex={0}
                    aria-controls="quick-links-list"
                    aria-expanded={isExpanded}
                >
                    Quick Links
                    {!isExpanded ? <FontAwesomeIcon icon={"chevron-down"} /> : <FontAwesomeIcon icon={"chevron-up"} />}
                </div>
            </Container>
            <Collapse in={isExpanded}>
                <div id="quick-links-list">
                    <Container className="header-quick-links d-md-none">
                        {isGuest && <CreateAccount />}
                        {(isGuest ? guestQuickLinks : quickLinks).map((item, index) => (
                            <QuickLink key={index} text={item.text} href={item.href} icon={item.icon} iconClassName={item.iconClassName} />
                        ))}
                    </Container>
                </div>
            </Collapse>
        </nav>
    );
}

const contactsLink: QuickLinkProps = {
    text: "Contacts",
    href: PageLink.Contacts,
};

const logoutLink: QuickLinkProps = {
    text: "Logout",
    href: PageLink.SignOut,
    icon: "right-from-bracket",
    iconClassName: "d-block",
};

const quickLinks: QuickLinkProps[] = [
    contactsLink,
    {
        text: "My profile",
        href: PageLink.AccountDetails,
    },
    {
        text: "Change password",
        href: PageLink.ChangePassword,
    },
    {
        text: "Change email",
        href: PageLink.ChangeEmail,
    },
    logoutLink,
];

const guestQuickLinks: QuickLinkProps[] = [contactsLink, logoutLink];

const CreateAccount = () => {
    const [show, setShow] = useState(false);
    return (
        <>
            <button
                onClick={() => setShow(true)}
                className="px-0 text-start quick-link-item menu-link bg-transparent border-0 text-decoration-underline"
            >
                Create Account
            </button>

            <AccountForm show={show} onClose={() => setShow(false)} />
        </>
    );
};
